/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ElementTabTypesInfo,
  ElementType,
  ProjectElementBoundingBoxToUpdateInfo,
  ProjectElementInfo,
  ProjectElementToAddInfo,
  ProjectElementToUpdateInfo,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectElementClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectElement
   * @summary Получить элементы дерева объектов верхнего уровня по Id проекта
   * @request GET:/objecttree/ProjectElement/project/{projectId}
   * @secure
   */
  projectElementGetTopLevelElementsByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectElementInfo[], any>({
      path: `/objecttree/ProjectElement/project/${projectId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Получить элементы дерева объектов по Id родительского элемента
   * @request GET:/objecttree/ProjectElement/project/{projectId}/parent/{parentId}
   * @secure
   */
  projectElementGetElementsByParentId = (
    projectId: string,
    parentId: string,
    query?: {
      /**
       * Id вкладки
       * @format uuid
       */
      tabId?: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectElementInfo[], any>({
      path: `/objecttree/ProjectElement/project/${projectId}/parent/${parentId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Получить элемент дерева по параметрам проектной сущности
   * @request GET:/objecttree/ProjectElement/project/{projectId}/projectEntity/{projectEntityId}/elementType/{elementType}
   * @secure
   */
  projectElementGetElementByProjectEntity = (
    projectId: string,
    projectEntityId: string,
    elementType: ElementType,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectElementInfo, any>({
      path: `/objecttree/ProjectElement/project/${projectId}/projectEntity/${projectEntityId}/elementType/${elementType}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Получить дочерние элементы по идентификаторам сущностей родительских элементов
   * @request POST:/objecttree/ProjectElement/project/{projectId}/parentType/{parentType}/childsByParentEntityIds
   * @secure
   */
  projectElementGetElementsByParentEntityId = (
    projectId: string,
    parentType: ElementType,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectElementInfo[], any>({
      path: `/objecttree/ProjectElement/project/${projectId}/parentType/${parentType}/childsByParentEntityIds`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Публикация элемента по Id элемента
   * @request POST:/objecttree/ProjectElement/project/{projectId}/publishElement/{elementId}
   * @secure
   */
  projectElementPublishElement = (
    projectId: string,
    elementId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/objecttree/ProjectElement/project/${projectId}/publishElement/${elementId}`,
      method: 'POST',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Публикация элемента по Id сущности
   * @request POST:/objecttree/ProjectElement/project/{projectId}/publishElementByEntityId/{entityId}/type/{elementType}
   * @secure
   */
  projectElementPublishElementByEntityId = (
    projectId: string,
    entityId: string,
    elementType: ElementType,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/objecttree/ProjectElement/project/${projectId}/publishElementByEntityId/${entityId}/type/${elementType}`,
      method: 'POST',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Получить месторождения проекта
   * @request GET:/objecttree/ProjectElement/project/{projectId}/fields
   * @secure
   */
  projectElementGetFieldsByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectElementInfo[], any>({
      path: `/objecttree/ProjectElement/project/${projectId}/fields`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Получить элементы проекта по типам
   * @request POST:/objecttree/ProjectElement/project/{projectId}/byTypes
   * @secure
   */
  projectElementGetElementsByTypes = (
    projectId: string,
    data: ElementType[],
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectElementInfo[], any>({
      path: `/objecttree/ProjectElement/project/${projectId}/byTypes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Получить элементы проекта, пересекающиеся с координатами X, Y скважины
   * @request POST:/objecttree/ProjectElement/project/{projectId}/well/{wellId}/byTypes
   * @secure
   */
  projectElementGetElementsByTypesForWell = (
    projectId: string,
    wellId: string,
    data: ElementType[],
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectElementInfo[], any>({
      path: `/objecttree/ProjectElement/project/${projectId}/well/${wellId}/byTypes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Проверить существует ли элемент дерева
   * @request GET:/objecttree/ProjectElement/isExist/{projectId}/{entityId}
   * @secure
   */
  projectElementIsExistElementByEntityId = (
    projectId: string,
    entityId: string,
    query: {
      /** Типы объектов */
      elementType: ElementType
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/objecttree/ProjectElement/isExist/${projectId}/${entityId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Получить элементы с типами вкладок, на которых используются.
   * @request POST:/objecttree/ProjectElement/ElementsWithTabTypes
   * @secure
   */
  projectElementGetElementsWithTabTypes = (data: string[], params: RequestParams = {}) =>
    this.http.request<ElementTabTypesInfo[], any>({
      path: `/objecttree/ProjectElement/ElementsWithTabTypes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Добавить новый элемент дерева объектов
   * @request POST:/objecttree/ProjectElement
   * @secure
   */
  projectElementAddProjectElement = (data: ProjectElementToAddInfo, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/objecttree/ProjectElement`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Изменить существующий элемент дерева объектов
   * @request PUT:/objecttree/ProjectElement
   * @secure
   */
  projectElementUpdateProjectElement = (
    data: ProjectElementToUpdateInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/objecttree/ProjectElement`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Удалить существующий элемент дерева объектов
   * @request DELETE:/objecttree/ProjectElement
   * @secure
   */
  projectElementDeleteProjectElement = (
    query: {
      /**
       * Идентификатор элемента дерева объектов
       * @format uuid
       */
      elementId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/objecttree/ProjectElement`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Создать элементы по умолчению по Id проекта в соответствии с конфигуратором.
   * @request POST:/objecttree/ProjectElement/CreateDefaultElements
   * @secure
   */
  projectElementCreateDefaultElements = (
    query: {
      /**
       * Идентификатор проекта
       * @format uuid
       */
      projectId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/objecttree/ProjectElement/CreateDefaultElements`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectElement
   * @summary Изменить баундинг бокс для существующего элемента дерева объектов
   * @request PUT:/objecttree/ProjectElement/boundingbox
   * @secure
   */
  projectElementUpdateProjectElementBoundingBox = (
    data: ProjectElementBoundingBoxToUpdateInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/objecttree/ProjectElement/boundingbox`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectElement
 * @summary Получить Id кубов, значимые для учёта размера проекта.
Т.к. кубы переиспользуются в разных проектах, в результат включаются 
только те кубы проекта, у которых дата добавления в проект максимальная 
среди всех одинаковых (НЕ удаленные в корзину) кубов других проектов.
 * @request GET:/objecttree/ProjectElement/project/{projectId}/CubesForSize
 * @secure
 */
  projectElementGetValuableCubeIds = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/objecttree/ProjectElement/project/${projectId}/CubesForSize`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
